import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import KioskHeader from './KioskHeader';
import { useKiosk } from '../../contexts/KioskContext';
import '../../views/Kiosk/KioskStyles.scss';

export default function KioskLayout({ children }) {
  const { school } = useKiosk();

  // Apply dynamic theming
  useEffect(() => {
    if (school?.theme) {
      const root = document.documentElement;
      if (school.theme.primaryColor) {
        root.style.setProperty('--kiosk-primary-color', school.theme.primaryColor);
      }
      if (school.theme.secondaryColor) {
        root.style.setProperty('--kiosk-secondary-color', school.theme.secondaryColor);
      }
    }
  }, [school]);

  return (
    <div className="kiosk-layout">
      <KioskHeader />
      <Box className="kiosk-content">
        {children}
      </Box>
    </div>
  );
}
